import { axiosWithAuth } from "../../helpers";

export const merchantPaymentsService = {
	deleteMerchantPaymentMethod,
	getMerchantPaymentMethod,
	editActivePaymentMethod,
	addPaymentMethod,
	getPaymentMethod,
	updatePaymentMethod,
};

const PAGE_SIZE = 50;
const API_URL = process.env.REACT_APP_API_URL;

function getMerchantPaymentMethod({ merchantId, page, sortBy }) {
	return axiosWithAuth({
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy?.id || undefined,
			ascending: sortBy?.desc,
			merchant_id: merchantId,
		},
		url: `${API_URL}/api/payment_methods`,
	});
}

function addPaymentMethod({
	data,
	id,
}: {
	data: { [key: string]: any };
	id: string;
}) {
	return axiosWithAuth({
		method: "POST",
		data: data,
		url: `${API_URL}/api/merchants/${id}/payment_methods`,
	});
}

function getPaymentMethod({
	id,
	paymentMethodId,
}: {
	id: string;
	paymentMethodId: string;
}) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${id}/payment_methods/${paymentMethodId}`,
	};

	return axiosWithAuth(options);
}

function updatePaymentMethod({
	data,
	id,
	paymentMethodId,
}: {
	data: { [key: string]: any };
	id: string;
	paymentMethodId: string;
}) {
	return axiosWithAuth({
		method: "PUT",
		data: data,
		url: `${API_URL}/api/merchants/${id}/payment_methods/${paymentMethodId}`,
	});
}

function deleteMerchantPaymentMethod({ userId, paymentMethodId }) {
	return axiosWithAuth({
		method: "DELETE",
		url: `${API_URL}/api/merchants/${userId}/payment_methods/${paymentMethodId}`,
	});
}

function editActivePaymentMethod({ userId, paymentMethodId, active }) {
	return axiosWithAuth({
		method: "PUT",
		url: `${API_URL}/api/merchants/${userId}/payment_methods/${paymentMethodId}/update_active_status?is_active=${active}`,
	});
}
